import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { openModal } from './uiSlice';
import { ModalComponent } from '../../types/modal';
import { getCurrentPosition } from '../../api/geolocation';
const initialState = {
    region: null,
    position: null,
    positionError: null,
    isPositionPending: false,
};
export const fetchPosition = createAsyncThunk('location/fetchPosition', async (arg, { rejectWithValue, dispatch }) => {
    try {
        const position = await getCurrentPosition();
        return JSON.stringify(position);
    }
    catch (e) {
        dispatch(openModal({ component: ModalComponent.LocationNotFound }));
        return rejectWithValue(JSON.stringify({
            code: e.code,
            message: e.message,
        }));
    }
});
export const locationSlice = createSlice({
    name: 'location',
    initialState,
    selectors: {
        getPosition(state) {
            return state.position;
        },
        getPositionError(state) {
            return state.positionError;
        },
        getRegion(state) {
            return state.region;
        },
        getIsPositionPending(state) {
            return state.isPositionPending;
        },
    },
    extraReducers: builder => {
        builder.addCase(fetchPosition.pending, state => {
            state.isPositionPending = true;
        });
        builder.addCase(fetchPosition.fulfilled, (state, action) => {
            const payload = JSON.parse(action.payload);
            state.isPositionPending = false;
            state.position = payload;
            window.dataLayer.push({
                event: 'storeLocatorUserLocationReceived',
            });
        });
        builder.addCase(fetchPosition.rejected, (state, action) => {
            const payload = JSON.parse(action.payload);
            state.isPositionPending = false;
            state.positionError = payload;
            window.dataLayer.push({
                event: 'systemError',
                errorType: 'store locator user location',
                errorMessage: {
                    1: 'permission denied',
                    2: 'position unavailable',
                    3: 'timeout',
                }[payload.code],
            });
        });
    },
    reducers: () => ({
        setRegion: (state, action) => {
            state.region = action.payload;
        },
    }),
});
export const { getPosition, getIsPositionPending, getPositionError, getRegion } = locationSlice.selectors;
export const { setRegion } = locationSlice.actions;
